/**
 * Performance Optimization Utilities
 * Handles critical CSS inlining, resource loading, and performance monitoring
 */

/**
 * Initialize all performance optimizations
 */
export const initializePerformanceOptimizations = () => {
  // Initialize Core Web Vitals monitoring
  if (typeof window !== 'undefined' && 'PerformanceObserver' in window) {
    console.log('Initializing performance monitoring...');
  }
  
  // Optimize images after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', optimizePageImages);
  } else {
    optimizePageImages();
  }
};

/**
 * Optimize images on the page
 */
export const optimizePageImages = () => {
  if (typeof document === 'undefined') return;

  const images = document.querySelectorAll('img:not([loading])');
  images.forEach((img, index) => {
    // Add loading="lazy" to images below the fold
    if (index > 2) { // First 3 images load eagerly
      img.loading = 'lazy';
    }
  });
}; 